import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import { WorkerList, WorkerImage, UnitPrice } from "@/types";
import List from '@/assets/common/List/List.vue';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import UnitPrices from '@/components/UnitPrices/UnitPrices.vue'
import store from '@/assets/common/store/store';

interface Params {
    name?: string;
    role?: string;
    mail?: string;
    memo?: string;
    unit?: any;
}

@Component({
    components: {
        List,
        Thumbnail,
        UnitPrices
    }
})
export default class Workers extends Vue {
    private list: any | null = null
    private unitPrice: any | null = null
    private tableTitle = '作業者情報'
    private title = '作業者'
    private workers: WorkerList[] = []
    private workerId = ''
    private workerName = ''
    private workerLoginId = ''
    private workerRole = ''
    private workerMail = ''
    private workerMemo = ''
    private workerUnitPrices: UnitPrice[] = []
    private workerImage: WorkerImage = {
        id: '',
        url: '',
        file: null
    }
    private hasNotWorkerName = false
    private isMailFormat = true
    private isAdmin = false
    private isContractAdmin = false
    private isMyself = false
    private userId = ''
    private isLoading = false
    private baseUrl = '/workers'
    private clientBaseUrl = '/master/workers'
    private unitPricesTitle = '作業者'
    private isDeleteImage = false
    private accountManagerUrl = process.env.VUE_APP_ACCOUNT_MANAGER_URL
    private changePasswordUrl = `${process.env.VUE_APP_ACCOUNT_MANAGER_URL}/accounts/security`

    @Prop()
    private id!: string

    private created() {
        this.$apiClient.getUserProfile().then((ret) => {
            if(ret.role && ret.role.indexOf('ADMIN') != -1) {
                this.isAdmin = true
            }
            this.userId = ret.id
        })
        this.getWorkers()
    }

    private getWorkers() {
        // 作業者リストを取得する
        this.isLoading = true
        this.$apiClient.doRequest('get', this.baseUrl).then((ret) => {
            this.workers = ret.workers
        })
        .finally(() => {
            this.list = List
            this.isLoading = false
        })
    }

    private setWorker(workerId: string){
        this.$router.push(this.clientBaseUrl + '/' + workerId, () => {return})
        if(store.getters.isInputChanged==false){
        this.workerImage = {
            id: '',
            url: '',
            file: null
        }
        this.unitPrice = null
        this.isMailFormat = true
        this.hasNotWorkerName = false
        this.isDeleteImage = false
        // クリックした作業者の情報を取得してフォームに渡す
        if(this.isAdmin){
            this.$apiClient.doRequest('get', `/admin${this.baseUrl}/${workerId}`).then((ret) => {
                this.isMyself = (this.userId == ret.id)
                this.workerId = ret.id
                this.workerLoginId = ret.login_id
                this.workerName = ret.name
                this.workerRole = ret.role.indexOf('ADMIN') != -1 ? 'ADMIN' : 'USER'
                this.workerMail = ret.mail
                this.workerMemo = ret.memo
                this.workerUnitPrices = ret.unit
                this.unitPrice = UnitPrices
                if(ret.image_id) {
                    this.$apiClient.doRequest('get', `${this.baseUrl}/${workerId}/image`).then(ret => {
                        this.workerImage = ret
                    })
                }
            })
        }else {
            this.$apiClient.doRequest('get', `${this.baseUrl}/${workerId}`).then((ret) => {
                this.isMyself = (this.userId == ret.id)
                this.workerId = ret.id
                this.workerName = ret.name
                if(this.isMyself) {
                    this.workerLoginId = ret.login_id
                    this.workerRole = ret.role.indexOf('ADMIN') != -1 ? 'ADMIN' : 'USER'
                    this.workerMail = ret.mail
                }
            })
        }
    }
    }

    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if(this.$apiClient.isSizeOver(files)) {
            return
        }

        if(this.$apiClient.isImageFile(files[0].name)){
            this.workerImage.file = files[0]

            this.$apiClient.getBase64(files[0]).then((image: any) => {
                this.workerImage.url = image.base64 as string
            }).catch(() => {
                window.alert('画像ファイルが読み込めませんでした')
            });
        }else {
            window.alert('画像ファイルを選択してください')
        }
        this.inputChanged()
    }

    private clearImage() {
        this.workerImage.url = ''
        this.workerImage.file = null
        this.isDeleteImage = true
        this.inputChanged()
    }

    private cancelEdit() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        this.setWorker(this.workerId)
    }

    private async submit() {
        let errmsg: string[] = []
        if(!this.workerName) {
            errmsg.push('作業者名を入力してください')
        }
        if(this.workerName.length > 255) {
            errmsg.push(`作業者名は255文字以内で入力してください（現在は${this.workerName.length}文字）`)
        }
        if(this.workerMail && this.workerMail.length > 255) {
            errmsg.push(`メールアドレスは255文字以内で入力してください（現在は${this.workerMail.length}文字）`)
        }
        if(this.workerMail && !this.validateMail(this.workerMail)) {
            errmsg.push('メールアドレスの形式で入力してください')
        }
        if(this.workerMemo && this.workerMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.workerMemo.length}文字）`)
        }
        const refs: any = this.$refs
        let unitPrices
        if(refs.unitPrices) {
            unitPrices = refs.unitPrices.getUnitPrices()
            // 戻ってきた型がstring[]だったらエラーメッセージの配列
            if(unitPrices.length > 0 && typeof unitPrices[0] === 'string') {
                errmsg = errmsg.concat(unitPrices)
            }
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            this.isLoading = false
            return false
        }

        this.isLoading = true
        const result = window.confirm("内容を上書きして保存します。よろしいですか。")
        if (!result) {
            this.isLoading = false
            return false;
        }
        let params: Params = {}
        const promises = []
        if(this.isAdmin) {
            params = {
                name: this.workerName,
                role: this.workerRole,
                mail: this.workerMail,
                memo: this.workerMemo,
                unit: unitPrices
            }
            await this.$apiClient.doRequest('put', `/admin${this.baseUrl}/${this.workerId}`, params).then(() => {
                // 削除オペレーションが行われている、且つDBに登録された画像が既に存在する場合する場合、削除を行う
                if(this.isDeleteImage && this.workerImage.id) {
                    promises.push(this.$apiClient.doRequest('delete', `/admin${this.baseUrl}/${this.workerId}/image`))
                }

                // ファイルが添付されている場合、画像をDBに登録
                if(this.workerImage.url && this.workerImage.file) {
                    promises.push(this.$apiClient.fileUpload(`/admin${this.baseUrl}/${this.workerId}/image`, this.workerImage.file))
                }
            })
            .catch(() => {
                promises.push(Promise.reject())
            })
        }else {
            params = {
                mail: this.workerMail
            }
            if(this.isMyself){
                promises.push(this.$apiClient.doRequest('put', `${this.baseUrl}/me`, params))
            }else {
                this.$toasted.error('編集する権限がありません。')
                this.isLoading = false
            }
        }
        Promise.all(promises).then(() => {
            this.workers = this.workers.map((worker: WorkerList) => {
                if(worker.id == this.workerId) {
                    worker.name = params.name ? params.name : worker.name
                }
                return worker
            })
            if(this.isAdmin || this.isMyself) {
                this.$toasted.success('変更を保存しました。')
                this.setWorker(this.workerId)
            }
        })
        .catch(() => {
            this.$toasted.error('変更に失敗しました。')
        })
        .finally(() => {
            this.isLoading = false
        })
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }

    private validateMail(mail: string) {
        const mailRegx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        return  mailRegx.test(mail)
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }
}